<template>
  <div class="hero">
    <div class="hero-grid">
      <div>
        <div class="pill">
          <span aria-hidden="true">⚕️</span>
          <span>Gestão feita para clínicas de neurodesenvolvimento</span>
        </div>

        <h1 class="hero-title">
          Simplifique a gestão da sua clínica e ganhe controle total da agenda e do financeiro com o EasySaúde
        </h1>

        <p class="hero-subtitle">
          Reduza retrabalho, evite erros e organize atendimentos com um sistema intuitivo para Psicologia, Terapias e
          acompanhamento de Autismo/TEA e TDAH.
        </p>

        <div class="hero-ctas">
          <a class="btn btn-primary" href="#formulario" @click="$posthog.capture('hero_cta_clicked')">
            Falar com especialista
          </a>

          <a
            v-if="whatsAppUrl"
            class="btn btn-secondary"
            :href="whatsAppUrl"
            target="_blank"
            rel="noopener noreferrer"
            @click="$posthog.capture('hero_whatsapp_clicked')"
          >
            Falar com um especialista
          </a>

          <router-link class="btn btn-secondary" to="/politica-privacidade">
            Política de privacidade
          </router-link>
        </div>

        <div class="hero-proof">
          <div class="proof-item">
            <span class="proof-icon" aria-hidden="true">⚡</span>
            <div>
              <div class="proof-title">Suporte rápido e eficiente</div>
              <div class="proof-sub">Resolução sem enrolação para o seu time trabalhar sem interrupções</div>
            </div>
          </div>
          <div class="proof-item">
            <span class="proof-icon" aria-hidden="true">🧠</span>
            <div>
              <div class="proof-title">Fluxo pensado para o cuidado</div>
              <div class="proof-sub">Do agendamento ao portal do responsável, tudo em um só lugar</div>
            </div>
          </div>
        </div>
      </div>

      <div class="hero-art">
        <div class="hero-login">
          <a class="btn btn-secondary hero-login-btn" :href="appLoginUrl" @click="$posthog.capture('hero_client_login_clicked')">
            Já é cliente, Clique aqui!
          </a>
        </div>
        <svg width="100%" height="100%" viewBox="0 0 520 430" role="img">
          <defs>
            <linearGradient id="g1" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stop-color="#4DBA87" stop-opacity="0.35" />
              <stop offset="100%" stop-color="#4DBA87" stop-opacity="0" />
            </linearGradient>
            <linearGradient id="g2" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stop-color="#0f172a" stop-opacity="0.12" />
              <stop offset="100%" stop-color="#0f172a" stop-opacity="0" />
            </linearGradient>
          </defs>
          <rect x="42" y="42" width="436" height="320" rx="26" fill="url(#g2)" stroke="rgba(15,23,42,0.10)" />
          <rect x="78" y="98" width="260" height="44" rx="14" fill="rgba(77,186,135,0.12)" />
          <rect x="78" y="160" width="360" height="20" rx="10" fill="rgba(15,23,42,0.06)" />
          <rect x="78" y="195" width="320" height="20" rx="10" fill="rgba(15,23,42,0.06)" />
          <rect x="78" y="230" width="290" height="20" rx="10" fill="rgba(15,23,42,0.06)" />
          <rect x="78" y="275" width="170" height="52" rx="16" fill="#4DBA87" fill-opacity="0.15" />
          <rect x="264" y="275" width="172" height="52" rx="16" fill="rgba(15,23,42,0.06)" />
          <circle cx="420" cy="95" r="92" fill="url(#g1)" />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeroSection',
  props: {
    appLoginUrl: { type: String, required: true },
    whatsAppUrl: { type: String, default: '' }
  }
}
</script>

<style scoped>
.hero {
  padding: 14px 0 14px 0;
}

.hero-grid {
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 26px;
  align-items: center;
}

.hero-art {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.hero-login {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  margin: 8px 0 18px;
}

.hero-login-btn {
  width: fit-content;
  padding: 10px 16px;
  border-radius: 999px;
}

.hero-title {
  font-size: 46px;
  line-height: 1.05;
  letter-spacing: -0.03em;
  margin: 16px 0 12px;
}

.hero-subtitle {
  font-size: 18px;
  line-height: 1.6;
  color: var(--easy-muted);
  margin: 0 0 18px;
  max-width: 58ch;
}

.hero-ctas {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin: 22px 0 18px;
}

.hero-proof {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  margin-top: 22px;
}

.proof-item {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 14px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(15, 23, 42, 0.08);
  backdrop-filter: blur(6px);
}

.proof-icon {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(77, 186, 135, 0.12);
  flex: 0 0 auto;
}

.proof-title {
  font-weight: 900;
}

.proof-sub {
  margin-top: 4px;
  color: var(--easy-muted);
  font-size: 14px;
  line-height: 1.4;
}

@media (max-width: 980px) {
  .hero-grid {
    grid-template-columns: 1fr;
  }

  .hero-login {
    margin: 10px 0 14px;
  }

  .hero-proof {
    grid-template-columns: 1fr;
  }

  .hero-title {
    font-size: 34px;
  }
}

@media (max-width: 720px) {
  .hero-ctas {
    flex-direction: column;
    align-items: flex-start;
  }

  .hero-ctas .btn {
    width: 100%;
  }
}
</style>
